module.exports = __webpack_public_path__ + "static/media/youtube.cc6a3a67.svg";